$ = require 'jquery'
h = require './helpers'

router = require './../components/router'
Observer = require '../components/observer'

tteStatuses = require './tte_statuses'

images_url = '//www.tourtrans.ru/js/online-styles/new/'

class OrderList
  applyStyles: ->
    console.log 'Применяю стили OrderList'
    $form = $('#aspnetForm')

#    $('body').removeClass().addClass('order_list')

    if $('.orderlist-content').length == 0
      # Блок "Список заявок"
      h.h1('Список заявок', 'h1-orderlist').appendTo $form
      [$row, $cont] = h.rowN(true, 'orderlist-content')
      $form.append $row

      if router.site() == 'online'
        $iframe = $ '<iframe/>',
          src: '//www.tourtrans.ru/pages/online-tips/frame10.html?iframe=true'
        $iframe.insertBefore $row

      [$block, $wrapper] = h.blockN 'Найти заявку', 'orders-filters'
      $block.appendTo $cont
      $wrapper.append $('#ctl00_generalContent_TabContainer1_TabPanel1 .frontPanel')

      # moved to css
      #$('#ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_orderListFilter_LbTitle2').hide() # Надпись "Укажите номер заявки или его часть"
      # Перемещаем галку "Задолженности"
      $td = $('#ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_orderListFilter_chkShowDebtors').parent()
      $td.children().appendTo $td.prev()
      # Перемещаем кнопку "Поиск" и переименовываем ее
      $btn = $('#ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_orderListFilter_btnSearch')
      $td.append $btn
      $btn.addClass('btn large')
      $btn.val('Показать')


      if router.site() == 'personal'
        $iframe = $('#ctl00_generalContent_TabContainer1_TabPanel1 iframe')
        $iframe.appendTo $cont
      else
        [$contracts, $wrapper] = h.blockN 'Договоры', 'contracts'
        $contracts.appendTo $cont
        $wrapper.append($('.CurrentAgentPartnerAgreementsTable'))

        $contracts.find('tr').each (i, e) ->
          if i == 0
            return
          $cols = $(e).find('td')
          $num = $cols.eq(0)
          $type = $cols.eq(1)
          $div = $ '<div/>'
          $div.text($type.text())
          $num.append $div

          $date = $cols.eq(2)
          date = $date.text()

          date = date.match /\d+\.\d+\.\d+/
          if date
            date = date[0]
            $span = $ '<span/>'
            $span.text(date)
            $date.empty().append($span)
            $(e).addClass('received')
          else
            $div = $ '<div/>'
            $img = $ '<img/>',
              src: images_url + 'icon_exclamation.svg'
            $div.append $img
            $div.append 'Оригинал не получен!'
            $date.append $div

      # Результаты поиска
      $cont.append($('#ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_UpdatePanel1'))
      @table()

      # Отслеживание изменений результатов поиска
      new Observer('ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_UpdatePanel1', 'dom', @observe)

  observe: =>
    @table()

  table: ->
    paystr = '';
    if ($('#ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl01_lbTitlePay').length)
      paystr = '<span class="HlPayment"><a class="disabled">Оплатить</a></span>'

    newOrdersTable = '''
<table class="orderListControl_ordersTable" id="newOrderListTable">
    <thead>
    <tr>
        <th class="lbTitleOrderCode">№ заказа</th>
        <th class="lbTitleFIO">ФИО</th>
        <th class="lbTitleTourDate">Дата тура</th>
        <th class="lbTitleNMen">Кол-во чел.</th>
        <th class="lbTitleTour">Тур</th>
        <th class="lbTitleCreationDate">Заказ поступил</th>
        <th class="lbTitlePaymentDate">Полная оплата до</th>
        <th class="lbTitleStatus">Статус заказа</th>
        <th class="lbTitlePriceNational"><nobr>К оплате</nobr></th>
        <th class="lbTitlePriceNational">Оплачено</th>
        <th class="actions"></th>
    </tr>
    </thead>
</table>
'''

    $('#ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable').after(newOrdersTable)

    newOrdersTbody = '<tbody><tr><td class="lnkOrderCode"><a id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl02_lnkOrderCode" href="//online.tourtrans.ru:8081/OrderInfo.aspx?dg_code=4AS12094A8">4AS12094A8</a></td><td class="lbFIO"><span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl02_lbFIO">GUIDE !.</span></td><td><div class="lbTourDate"><span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl02_lbTourDate">12.09.2014</span></div><div class="lbTourDateEnd"><span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl02_lbTourDateEnd">21.09.2014</span></div></td>			<td class="lbNMen"><span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl02_lbNMen">1</span></td><td class="lbTour"><span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl02_lbTour">4AS "Р—РЅР°РєРѕРјСЃС‚РІРѕ СЃРѕ РЁРІРµР№С†Р°СЂРёРµР№ + Р“РµСЂРјР°РЅРёСЏ" (10 РґРЅРµР№)</span></td><td class="lbCreationDate"><span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl02_lbCreationDate">14.08.2014</span></td><td class="lbPaymentDate"><span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl02_lbPaymentDate">08.09.2014</span></td><td class="lbOrderStatus"><span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl02_lbOrderStatus">РђРќРќРЈР›РР РћР’РђРќРђ</span></td><td class="Price_TD"><div class="lbPrice"></div></td><td class="Price_TD Payed_TD"><div class="lbPayed"></div></td><td class="actions">' + paystr + ' <a class="toggle_button"></a></td></tr>'
#    newOrdersTbody += '<tr><td colspan="11" class="more_info"><table class="more_info_item"><tr><td class="lbTitleBonus">Баллы / У.е.</td><td class="lbBonus_cover"><span class="lbBonus">10,00</span> &nbsp; <span class="lbBonusUnits">9,09</span>					</td>					</tr>				</table>				<table  class="more_info_item">					<tr>					<td class="lbTitleVisaDeadlineDate">						<span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl01_lbVisaDeadlineDate">РљСЂР°Р№РЅРёР№ СЃСЂРѕРє РїРѕРґР°С‡Рё РґРѕРєСѓРјРµРЅС‚РѕРІ РЅР° РІРёР·Сѓ</span>											</td>					<td class="lbVisaDeadlineDate">						<span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl02_lbVisaDeadlineDate"></span>					</td>					</tr>				</table>				<table  class="more_info_item">					<tr>					<td class="lbTitlePayedNational"><span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl01_lbPayedNational">РћРїР»Р°С‡РµРЅРѕ РЅР°С†. РІР°Р». </span>							</td>					<td class="lbPayedNational">						<span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl02_lbPayedNational"></span>					</td>					</tr>				</table>				<table  class="more_info_item">					<tr>					<td class="lbTitleVisaInfo"><span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl01_lbVisaInfo">РЎС‚Р°С‚СѓСЃ РґРѕРєСѓРјРµРЅС‚РѕРІ<br>РЅР° РІРёР·Сѓ</span>						</td>					<td class="lbVisaInfo">						<span id="ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable_ctl02_lbVisaInfo"></span>					</td>					</tr>				</table>				<table  class="more_info_item">					<tr>					<td class="temp_class">РћС‚РјРµС‚РєР° Рѕ РІС‹РґР°С‡Рµ РґРѕРєСѓРјРµРЅС‚РѕРІ							</td>					<td class="">РЅРµ РІС‹Р±СЂР°РЅРѕ					</td>					</tr>				</table>			</td>		</tr>	</tbody>'
    newOrdersTbody += require './../html/order_list_item.html'

    table = $('#newOrderListTable')

    $('#ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable > tbody > tr:not(.h1)').each ->
      table.append(newOrdersTbody);
      tbody = table.children('tbody').last()
      tbody.find('.more_info_item').hide()
      $(this).children('td').each (i) ->
        span = $(this).children()
        console.log('===', span.text(), i)
        if (span && span.attr('id'))
          idArr = span.attr('id').split('_')
          classStr = idArr[idArr.length - 1]

          cont = tbody.find('.' + classStr)

          if [9, 13, 16].indexOf(i) != -1
            span.text(span.text().replace('Eu', 'у.е.'))

          if (cont)
            cont.parents('.more_info_item').show()

          if (classStr != 'HlPayment')
            cont.html(span)
          else
            if span.html()
              cont.html(span)
            else
              cont.remove()

      tbody.find('.lnkOrderCode').prepend('<a class="toggle_button"></a>');

    console.log('Список статусов для замены', tteStatuses)
    if router.site() == 'personal'
      $('.HlPayment a').each ->
        status = $(this).closest('tr').find('.lbOrderStatus span').text().trim()
        console.log('Статус заявки', status, tteStatuses.indexOf(status))

        if tteStatuses.indexOf(status) != -1
          code = $(this).closest('tr').find('.lnkOrderCode a').last().text().trim()
          console.log('Код заявки', code)
          payUrl = "javascript:window.open('//personal.tourtrans.ru/yookassatte/Payment.aspx?orderCode=" + code + "&action=login', 'PaymentSystem'); return false;"
          console.log('Ссылка на оплату', payUrl)
          $(this).attr('onclick', payUrl)
          $(this).attr('href', 'Controls/#')
          $(this).removeClass('disabled')
          console.log('Ссылка на оплату установлена')
          # if payUrl && payUrl.length > 0
          #   payUrl = payUrl.replace('Sberbank', 'Sberbanktte')
          #   $(this).attr('onclick', payUrl)
          #   console.log('Ссылка на оплату заменена')


    $('.orderListControl_ordersTable').before('<div class="legend"><a href="#" class="btn open_all">Раскрыть все</a><div class="payed">Оплачено</div><div class="confirmed">Предварительное подтверждение</div><div class="annulated">Аннулировано</div><div class="booked">Временная бронь</div><a href="//www.tourtrans.ru/pages/online-tips/explain_status.html?iframe=true" class="btn explain fancybox_popup">Расшифровка статуса</a></div>')
    $('#ctl00_generalContent_TabContainer1_TabPanel1_orderListControl_ordersTable').hide()
    $('.lbTitleVisaInfo').find('br').remove()

    $('.toggle_button').click (e) ->
      e.preventDefault()
      $parent = $(this).closest('tbody')
      $parent.toggleClass('expanded')

    $('.open_all').click (e) ->
      e.preventDefault()
      table.find('tbody').addClass('expanded')


    orderStatuses = [
      {
        name: 'АННУЛИРОВАНА'
        rowClass: 'annulated'
      }
    ]
    $('.lbOrderStatus').each ->
      currName = $(this).children('span').html().trim();
      for status in orderStatuses
        if status.name == currName
#          if status.name
#            $(this).html(currName + ' <div class="tooltip2"><img src="//www.tourtrans.ru/images/wtf.png"><div class="tooltip2_body-top"><div class="tooltip2_header"></div><div class="tooltip2_text"><p>' + status.name + '</p></div></div></div>');
          if status.rowClass
            $(this).parents('tbody').first().addClass(status.rowClass);


module.exports = new OrderList
